function _isSiteConfig(object) {
  const isNullOrUndefined = value => value === null || value === undefined;

  if (isNullOrUndefined(object) || typeof object !== 'object') {
    return false;
  }

  const record = object;
  return !isNullOrUndefined(record.name) && !isNullOrUndefined(record.env) && !isNullOrUndefined(record.asset_copy) && !isNullOrUndefined(record.public_url) && !isNullOrUndefined(record.appShortName) && !isNullOrUndefined(record.appLongName) && !isNullOrUndefined(record.appDescription) && !isNullOrUndefined(record.appTintColor) && !isNullOrUndefined(record.appBackgroundColor);
}
/* Cannot use injectENV, as we are called in Document, without container setup & async support */


export const injectSiteConfig = () => {
  const configString = process.env['NEXT_PUBLIC_SITE_CONFIG'];

  if (configString === undefined || typeof configString !== 'string') {
    throw new Error("Unexpected data retrieving site config");
  }

  const siteConfig = JSON.parse(configString);

  if (!_isSiteConfig(siteConfig)) {
    throw new Error("Data retrieved is not a valid site config");
  }

  return siteConfig;
};